// extracted by mini-css-extract-plugin
export var light = "Layout-module--light--f3fc7";
export var main = "Layout-module--main--200a4";
export var spinner = "Layout-module--spinner--67b95";
export var supportsFullHero = "Layout-module--supports-full-hero--38013";